define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Backbone = require('backbone');
    var Marionette = require('marionette');
    var AppConfig = require("config/application");

    return Backbone.Marionette.AppRouter.extend({
        route: function(route, name, callback) {
            var cbk = function() {
                if (window.onbeforeunload) {
                    var confirmation = confirm(window.onbeforeunload());
                    if (confirmation) {
                        callback.apply(this, arguments);
                    } else {
                        window.history.back();
                    }
                } else {
                    callback.apply(this, arguments);
                }
            }.bind(this);

            Backbone.Marionette.AppRouter.prototype.route.call(this, route, name, cbk);
        },

        isExistPreviousHistoryPage: function (pageName) {
            if (app.Collections &&
                app.Collections.RouteHistory &&
                app.Collections.RouteHistory.length > 2) {

                return true;
            }
            return false;
        },

        isPreviousHistoryPage: function (pageName) {
            if (app.Collections &&
                app.Collections.RouteHistory &&
                app.Collections.RouteHistory.length >= 2) {

                if (app.Collections.RouteHistory[app.Collections.RouteHistory.length - 2] &&
                    app.Collections.RouteHistory[app.Collections.RouteHistory.length - 2][0] === pageName) {
                    return true;
                }

                return false;
            }
            return false;
        },

        onRoute: function (name, path, args) {
            app.Collections = app.Collections || {};
            app.Collections.RouteHistory = app.Collections.RouteHistory || [];
            app.Collections.RouteHistory.push(arguments);
            if (app.Collections.RouteHistory.length > 30) {
                app.Collections.RouteHistory.shift();
            }
            app.Vents.trigger('route:changed', name, path, args);
            // window.history.replaceState({}, document.title, location.href.split('?')[0]);
            $.arcticmodal('close');
            setTimeout(function() {
                app.checkNewUser();
            },0);
        },

        getPageNameByUrl: function (url) {
            var that = this;
            var pageName = '';
            _.each(this.appRoutes, function(page, route) {
                var re = that._routeToRegExp(route);
                if (re.test(url)) {
                    pageName = page;
                }
            });
            return pageName;
        },

        appRoutes: {
            '': 'Leads',

            'stats/source/:source': 'StatsSource',

            'statistic/source/:sourceId': 'StatisticSource',

            'statistic(?*querystring)': 'Statistic',
            'statistic/dynamics': 'StatisticDynamics',
            'statistic/vk': 'StatisticLvl2',

            'leads(?*querystring)': 'Leads',
            'leads/card(/:id)': 'LeadsCard',
            'leads/import': 'LeadsImport',
            'leads/export': 'LeadsExport',
            'leads/buying': 'LeadsBuying',

            'deals(?*querystring)': 'Deals',
            'deals?action=export': 'Deals',
            'deals?action=export_all': 'Deals',
            'deals/card(/:id)': 'DealsCard',
            'deals/import': 'DealsImport',
            'deals/export': 'DealsExport',

            'constructor': 'Constructor',

            'balance(?*querystring)': 'Balance',
            'balance/success': 'BalanceSuccess',
            'balance/error': 'BalanceError',

            //'chat': 'Chat',
            'chat(/:id)(?filter=:query)': 'Chat',

            'crater': 'Crater',
            'crater/edit_steps': 'CraterEdit',
            'crater/decomposition': 'CraterDecomposition',

            'staff': 'Staff',
            'staff/edit(/:id)': 'StaffEdit',
            'staff/statistic': 'StaffStatistic',
            'staff/change_password': 'StaffChangePassword',
            'staff/security': 'StaffSecurity',
            'staff/worklog': 'StaffWorklog',

            'widgets/callback': 'WidgetCallback',
            'widgets/social': 'WidgetSocial',
            'widgets/geolocation': 'WidgetGeolocation',
            'widgets/popdom': 'Popdom',
            'widgets/popdom/edit': 'PopdomEdit',
            'widgets/popdom/stats': 'PopdomStats',
            'widgets/blacklist': 'WidgetBlacklist',
            'widgets/offers': 'WidgetOffers',

            'telephony/online': 'TelephonyOnline',
            'telephony/offline': 'TelephonyOffline',
            'telephony/redirection': 'TelephonyRedirection',
            'telephony/welcome': 'TelephonyWelcome',
            'telephony/details': 'TelephonyDetails',
            'telephony/comands': 'TelephonyComands',
            'telephony/robot': 'TelephonyRobot',
            'telephony/calltracking': 'TelephonyCalltracking',
            'telephony/simcards'    : 'TelephonySimcards',
            'telephony/numbers'    : 'TelephonyNumbers',

            'partners': 'Partners',
            'partners/promo': 'PartnersPromo',

            'poll': 'PollPage',

            'reports': 'Reports',
            'reports/edit(/:id)': 'ReportsEdit',

            'telemarketing': 'Statistic',

            'access_error': 'AccessError',

            'contacts': 'Contacts',
            'contacts/card(/:id)': 'ContactsCard',

            'code/standart': 'CodeStandart',
            'code/advanced': 'CodeAdvanced',

            'tariffs': 'Tariffs',

            'logout': 'Logout',

            'tasks': 'Calendar',
            'tasks/task/:taskId': 'Calendar',

            'sites': 'Sites',

            'calendar': 'Calendar',
            'calendar/task(/)(:taskId)': 'Calendar',

            'mail-domains(/:param)': 'MailDomains',

            'test': 'Test',
            'test/admins': 'TestAdmins',
            'test/tickets': 'TestTickets',

            //'settings': 'Settings',
            'settings(/:tab)': 'Settings',
            'settings/integrations/amo': 'SettingsIntegrationsAmo',
            'calls-scheme-settings(/:id)': 'CallsSchemeSettings',
            'news'                 : 'News',
            'autofunnel'           : 'Autofunnel',
            'sms-sender-names'     : 'SmsSenderNames',
            'omniauth'             : 'Omnidesk',
            'tickets'             : 'Tickets',

        }
    });
});
